var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FormLeaflet_instances, _FormLeaflet_setInputBuSlug;
import $ from 'jquery';
import { Modal } from 'bootstrap';
import { Form } from '@/components/form/form';
import { destroyAlert, displayError } from './utils';
export class FormLeaflet {
    constructor() {
        _FormLeaflet_instances.add(this);
        this.selector = '.form-leaflet';
        if ($(this.selector).length === 0)
            return;
        new Form(this.selector, {
            onLoading: (formData) => {
                const $inputBuSlug = $('[name="bu_slug"]');
                const $inputProductId = $('[name="product_id"]');
                const $inputProductName = $('[name="product_name"]');
                destroyAlert($(this.selector));
                __classPrivateFieldGet(this, _FormLeaflet_instances, "m", _FormLeaflet_setInputBuSlug).call(this);
                formData.append('bu_slug', $inputBuSlug.val().toString());
                formData.append('product_id', $inputProductId.val().toString());
                formData.append('product_name', $inputProductName.val().toString());
                return {
                    formData
                };
            },
            onSuccess: (data) => {
                const $form = $(this.selector);
                const $parentModal = $form.parents('.modal');
                const { thankyouId } = $form.data();
                const $modalThankYou = $(thankyouId);
                if ($parentModal.length) {
                    const parentModal = Modal.getOrCreateInstance($parentModal[0]);
                    parentModal.hide();
                }
                if ($modalThankYou.length) {
                    const thankyouModal = new Modal($modalThankYou[0]);
                    thankyouModal.show();
                }
                ;
            },
            onError: (error) => {
                displayError($(this.selector), $(this.selector).find('.form-group:last'), error);
            },
        });
    }
}
_FormLeaflet_instances = new WeakSet(), _FormLeaflet_setInputBuSlug = function _FormLeaflet_setInputBuSlug() {
    const { pathname } = window.location;
    const segments = pathname.split('/');
    const $inputBuSlug = $('[name="bu_slug"]');
    const $inputProductName = $('[name="product_name"]');
    // solution 
    if (segments[2] === 'solutions' && segments[3] !== '') {
        const $activeLink = $('.megamenu-solutions a.is-active');
        $inputBuSlug.val($activeLink.attr('aria-controls'));
    }
    // download 
    if (segments[2] === 'resources' && segments[3] === 'downloads') {
        const $activeLink = $('.nav-classify .nav-link.active');
        $inputBuSlug.val($activeLink.attr('aria-controls'));
    }
    // environmental
    if (segments[2] === 'environmental') {
        // overview
        if (segments.length === 4) {
            const $activeLink = $('.nav-classify .nav-link.active');
            $inputBuSlug.val($activeLink.attr('aria-controls'));
        }
        // environmental detail
        if (segments.length === 5) {
            const $thirdBreadcrumb = $('.breadcrumb .breadcrumb-item.active')[2];
            $inputProductName.val($thirdBreadcrumb.textContent.trim());
        }
    }
    // products
    if (segments[2] === 'products') {
        // overviews
        if (segments.length === 4) {
            const $activeLink = $('.nav-classify .nav-link.active');
            $inputBuSlug.val($activeLink.attr('aria-controls'));
        }
        // category 
        if (segments.length === 5) {
            const $activeLink = $('.breadcrumb .breadcrumb-item.active a');
            $inputBuSlug.val($activeLink.attr('aria-controls'));
        }
        // product detail
        if (segments.length === 7) {
            const $breadCrumbItems = $('.breadcrumb .breadcrumb-item');
            const breadcrumbCount = $breadCrumbItems.length;
            const $firstBreadcrumb = $breadCrumbItems[0];
            const $lastBreadcrumb = $breadCrumbItems[breadcrumbCount - 1];
            $inputBuSlug.val($firstBreadcrumb.getAttribute('aria-controls'));
            $inputProductName.val($lastBreadcrumb.textContent.trim());
        }
    }
};
